module.exports = __webpack_public_path__ + "img/7.e34ac97b.jpg";